import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { RatingSystem, withi18n } from "../../../../../customer/components";
import CustomerDialogueWrapper from "../customer-dialogue-wrapper/CustomerDialogueWrapper";
import { getCustRatingDialogueProps } from "../../../../../expert";
import Typography from "@limitless/modern/data-display/typography/Typography";
const CustomerDialogueScore = ({
  t,
  classes,
  dialogue,
  message
}) => {
  const {
    ratingMessage,
    translationKey,
    body
  } = React.useMemo(() => getCustRatingDialogueProps({
    t,
    message,
    dialogue
  }), [message.messageId]);
  return /*#__PURE__*/React.createElement(CustomerDialogueWrapper, {
    dialogue: dialogue,
    message: message
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ratingContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginRight: 14
    }
  }, "Customer rating:"), /*#__PURE__*/React.createElement(RatingSystem, {
    message: ratingMessage,
    moderniseStar: true,
    disabled: true,
    fontSize: 24,
    useDefaultScore: false,
    compact: true
  })), translationKey !== body && /*#__PURE__*/React.createElement("div", {
    className: classes.bodyContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, "Testimonial:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.textStyling
  }, body)));
};
const styles = () => ({
  ratingContainer: {
    display: "flex",
    alignItems: "center"
  },
  bodyContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 16
  },
  textStyling: {
    marginLeft: 12,
    wordWrap: "break-word",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    overflow: "hidden"
  }
});
export default withStyles(styles)(withi18n(CustomerDialogueScore));
CustomerDialogueScore.propTypes = {
  t: PropTypes.func.isRequired,
  dialogue: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};